"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-stino-di-livenza": {
    "b320c7be": [{
      "hkey": "b11b48e8",
      "slug": "san-stino-di-livenza",
      "name": "San Stino di Livenza",
      "primary": true,
      "skipSearch": false
    }],
    "bivio-triestina": [{
      "hkey": "b11b48e8",
      "slug": "san-stino-di-livenza",
      "name": "San Stino di Livenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;